import React from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { CTAButton } from './ui/CTAButton';
export function Hero() {
  const {
    scrollY
  } = useScroll();
  // Parallax más sutil - la imagen se mueve pero no desaparece
  const y = useTransform(scrollY, [0, 500], [0, 100]);
  return <header className="relative min-h-[90vh] flex items-center justify-center overflow-hidden bg-[#0f4c3a] text-[#f4e5c3] pt-12 pb-32" data-id="element-67">
      {/* Background Elements */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-[#1a5c4a] via-[#0f4c3a] to-[#0a3327] opacity-100" data-id="element-68" />
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-5 mix-blend-overlay" data-id="element-69" />

      <div className="container mx-auto px-4 md:px-6 relative z-10" data-id="element-70">
        <div className="flex flex-col md:flex-row items-center gap-8 md:gap-12" data-id="element-71">
          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="flex-1 text-center md:text-left" data-id="element-72">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2,
            duration: 0.6
          }} className="inline-block mb-4 px-3 py-1 border border-[#d4af37]/30 rounded-full text-[#d4af37] text-sm font-medium tracking-wider uppercase" data-id="element-73">
              Si la Quincena Se Te Va… No Es Falta de Disciplina
            </motion.div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif font-bold leading-tight mb-6 text-white" data-id="element-74">
              Es <span className="text-[#d4af37] italic" data-id="element-75">Programación</span>
            </h1>

            <p className="text-lg md:text-xl text-[#f4e5c3]/90 mb-6 font-light leading-relaxed max-w-xl mx-auto md:mx-0" data-id="element-76">
              ABUNDANCIA & DINERO — Reprograma tu mente + alinea tu energía +
              aplica un sistema simple (para que el dinero se quede y crezca sin
              culpa)
            </p>
          </motion.div>

          {/* Book Image with CTA below */}
          <motion.div style={{
          y
        }} className="flex-1 relative max-w-md w-full" data-id="element-77">
            <div className="relative z-10" data-id="element-78">
              <motion.div initial={{
              opacity: 0,
              scale: 0.9,
              rotate: -2
            }} animate={{
              opacity: 1,
              scale: 1,
              rotate: 0
            }} transition={{
              duration: 1,
              ease: 'easeOut',
              delay: 0.3
            }} className="relative mb-8" data-id="element-79">
                {/* Glow effect behind book */}
                <div className="absolute inset-0 bg-[#d4af37] blur-[60px] opacity-20 rounded-full transform translate-y-10" data-id="element-80" />

                <img src="https://cdn.magicpatterns.com/uploads/3mPw2ZWogtMmtJ5ZB9R4tT/Abundancia_y_Dinero_Libro.png" alt="Libro Abundancia y Dinero" className="w-full h-auto drop-shadow-2xl transform hover:scale-105 transition-transform duration-700 ease-out rounded-[12px]" data-id="element-81" />
              </motion.div>

              {/* CTA Button below book */}
              <div className="flex flex-col items-center gap-3" data-id="element-82">
                <CTAButton data-id="element-83" />
                <span className="text-sm text-[#f4e5c3]/60 italic" data-id="element-84">
                  Acceso inmediato
                </span>
              </div>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.5,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-[#d4af37]/60" data-id="element-85">
        <span className="text-xs tracking-widest uppercase" data-id="element-86">Descubre más</span>
        <div className="w-[1px] h-12 bg-gradient-to-b from-[#d4af37] to-transparent" data-id="element-87" />
      </motion.div>
    </header>;
}